<script lang="ts">
  import { get } from 'svelte/store'
  import { ExpandedNav } from '@packages/ui'
  import type { TExpandedNavProps } from '@packages/utils/types'
  import { configStore } from '@src/stores/config'

  export let options: TExpandedNavProps

  const isWalletAssetsConfigured = !!get(configStore).walletAssets?.length
</script>

<ExpandedNav {options} showAssets={isWalletAssetsConfigured} />
